export function buildURLQuery(obj) {
  return Object.entries(obj)
    .map((pair) => pair.map(encodeURIComponent).join('='))
    .join('&');
}

export function buildURLPath(arr) {
  return arr
    .map((v) => encodeURIComponent(v))
    .join('/');
}
